import React, { useState, useEffect } from 'react';
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst"
import { StyleRoot } from 'radium';
export default function ModaleConfirmationReset(props) {
    const [styleFadeIn, setFadeIn] = useState(true);
    const closeModaleConfirmationReset = React.useCallback(
        () => {
            setFadeIn(false)
            setTimeout(() => {
                props.closeModaleInfo()
            }, 400);
        },
        []
    );

    const ConfirmationReset = React.useCallback(
        (e) => {
            e.preventDefault();
            setFadeIn(false)
            setTimeout(() => {
                props.closeModaleInfo()
            }, 400);
        },
        []
    );

    return (
        <StyleRoot>
            <div className="modal fade modal-skin show actif" id="modalDelete" tabIndex="-1" role="dialog" aria-hidden="true"
                style={styleFadeIn === true ? styles.bounce : styles.bounce2}
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModaleConfirmationReset}>
                                <Close className="img-fluid" alt="" />
                            </button>
                            <div className="modal-body">
                                <section>
                                    <h5 className="modal-title">Modification de l'équipe</h5>
                                </section>
                                <section>
                                    <h5>Vous ne pouvez pas modifier le staffing d'une journée passée</h5>
                                </section>
                                <p className="bottom-space"></p>
                                <section>
                                    <div className="d-flex justify-content-center">
                                        <button onClick={ConfirmationReset} className="btn-gradient btn-confirm" > Ok</button>
                                    </div>
                                </section>
                            </div>
                    </div>
                </div>
            </div>
        </StyleRoot>

    )
}